module.exports = __webpack_public_path__ + "static/Clothes4All-Beach-NO_with-descriptions-19ba1dc144432b77880a40604d062e9e.mp4";